import { render, staticRenderFns } from "./NewAssignedLoansRequest.vue?vue&type=template&id=638b5c77&"
import script from "./NewAssignedLoansRequest.vue?vue&type=script&lang=js&"
export * from "./NewAssignedLoansRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports